import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import {Link, useParams} from 'react-router-dom'
import  '../assets/produit.css'
import  '../assets/see-product.css'
import Footer from './Footer'
import '../assets/modal-panier.css'

function Produit() {
  let header = document.querySelector('#menu');
      header?.classList.add('scrolled');
    let params = useParams();
    const [current_product, setCurrent_product] = useState([]);
    const produits = [{
      id: 1,
      nom: "Gelato HHCP 7%",
      prix: "13,90€ - 11,00€/g",
      note: "4,5",
      avis: "8",
      image: "/images/produits/gelato.png"
    },{
      id: 2,
      nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
      prix: "7,00€ - 6,00€/g ",
      note: "4,5",
      avis: "8",
      image: "/images/produits/pack.png"
    },{
      id: 3,
      nom: "Fruity Punch HHC 50% + CBD 10%",
      prix: "13,90€ - 11,00€/g",
      note: "4,5",
      avis: "8",
      image: "/images/produits/fruity.png"
    },{
      id: 4,
      nom: "Runtz HHC 50% + 10% CBD",
      prix: "13,90€ - 11,00€/g",
      note: "4,5",
      avis: "8",
      image: "/images/produits/runz.png"
    },{
      id: 5,
      nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
      prix: "7,00€ - 6,00€/g ",
      note: "4,5",
      avis: "8",
      image: "/images/produits/pack.png"
    }
  ];

  let [num, setNum]= useState(0);
  let incNum =()=>{
    if(num<10)
    {
    setNum(Number(num)+1);
    }
  };
  let decNum = () => {
     if(num>0)
     {
      setNum(num - 1);
     }
  }
  let handleChange = (e)=>{
   setNum(e.target.value);
  }

 
  useEffect(()=>{
    let prod = produits.filter(prod => prod.id === parseInt(params.id));
    if (prod) {     
      setCurrent_product(prod[0])
    }

    let header = document.querySelector('#menu');
    let burger = document.querySelector('.navbar-toggler');
    header?.classList.add('bg-navbar');

    if (window.screen.width < 985) {
      header?.classList.remove('scrolled');
      header?.classList.remove('bg-navbar');
      header?.classList.add('menuPanierOuProduit');
      burger?.classList.add("menuburger");
    }
  }, [])
  return (
    <div>
        <Navbar/>
       { current_product && <div className="container produit mt-5" id='product'>
          <div className="left">
            <img src={window.location.origin +current_product.image} alt="" />
          </div>
          <div className="right">
            <h1 className='title'>{current_product.nom}</h1>
            <p className='item-note'>
              <span> {current_product.note}</span> <span><img src={window.location.origin +"/images/start.png"} alt="" /></span><span className='avis'> {current_product.avis} avis</span>
            </p>
            <h2 className='prix'>{current_product.prix}</h2>
            <p className='taxe'>Taxes incluses. Frais d'expédition calculés à l'étape de paiement.</p>
            <p className='desc'>
            Produite dans les laboratoires Français à partir de fleurs de culture indoor de Suisse. Si vous êtes à la recherche de fleur aux saveurs et goûts délicieux de biscuit, La fleur HHC 40% Biscotti est faite pour vous !
            </p>
            <span className='degressif'>Prix dégréssif selon la quantité</span>
            <div className="gramme">
              <button>1 gramme</button>
              <button>2 grammes</button>
              <button>4 grammes</button>
              <button>6 grammes</button>
              <button>10 grammes</button>
              <button>20 grammes</button>
            </div>
            <div className="stock mt-3">
              <div className="quantite container">
                <p className='qt-titre'>Quantité</p>
                <div className='input-panier'>
                  <div className="plus-minus-group mt-1">
                    <div className="input-group-prepend">
                      <button className="btn btn-dark text-white btn-minus" type="button" onClick={decNum}>-</button>
                    </div>
                    <input type="text" value={num} onChange={handleChange}/>
                    <div className="input-group-prepend ">
                      <button className="btn btn-dark btn-plus" type="button" onClick={incNum}>+</button>
                    </div>
                  </div>
                  <div className='add-panier' id="button-panier">
                    <button type="button" className='btn form-control add btn-outline-success mt-1 col-3' data-bs-toggle="modal" data-bs-target="#rightModal">Ajouter au panier</button>
                    <button type="button" className='btn form-control add btn-dark mt-1 col-6'>Acheter maintenant</button>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='info mt-4'>
                    <p className='p1'>Click & Collect disponible à SHOPTACBD PARIS 10 et PARIS 13</p>
                    <p className='p2'>Habituellement prêt en 10 minutes</p>
                    <p className='p3'>Vérifier la disponibilité dans d'autres boutiques</p>
                  </div>
                </div>
                <div className="col-md-12">
                  {/* accordion */}
                    <div className='text-center row justify-content-center p-acc pt-1 pb-1'> 
                      <div className="accordion col-md-7 panier-accordion ps-0 pe-0" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header panier-acc-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Accordion Item #1
                            </button>
                          </h2>
                          <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header panier-acc-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                              Accordion Item #2
                            </button>
                          </h2>
                          <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header panier-acc-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                              Accordion Item #3
                            </button>
                          </h2>
                          <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header panier-acc-header" id="headingFor">
                            <button className="accordion-button collapsed end-acc-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFor" aria-expanded="false" aria-controls="collapseFor">
                              Accordion Item #4
                            </button>
                          </h2>
                          <div id="collapseFor" className="accordion-collapse collapse" aria-labelledby="headingFor" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  {/* accordio */}
                </div>
              </div>
            </div>
          </div>
        </div>}
        <div className='container category-product mt-4' id='categoryProduct'>
              <div className="cat-header">
                  <h4 className='cat-title text-uppercase'>Vous aimerez aussi</h4>
              </div>
              <div className="cat-body mt-4">
                {
                  produits.map(prod => <div className="cat-item" key={prod.id}>
                                <Link className='item-title' to={"/produit/"+prod.id}><img src={prod.image} alt="" /></Link>
                                <h3><Link className='item-title' to={"/produit/"+prod.id}>{prod.nom}</Link></h3>
                                <p className='item-price'>{prod.prix} </p>
                                <p className='item-note'>
                                  <span> {prod.note}</span> <span><img src={window.location.origin +"/images/start.png"} alt="" /></span><span className='avis'> {prod.avis} avis</span>
                                  </p>
                            </div>)
                }
                  
              </div>
        </div>
          <div className='container see-containte detail-desc mb-5'>
            <div className='paragraphe'>
                <h1 className='titre text-center text-uppercase'>description detaillé</h1>
                <p className='text mt-1'>
                    Discrète, compacte et facile à emporter partout, la cigarette électronique 
                    ou aussi appelée e-cig pour e-liquide est un système électronique de vape. 
                    Elle permet d’utiliser les e-liquide à base de nicotine mais aussi des concentrés
                    de CBD ou HHC ultra-relaxants pouvant être aromatisés d’une saveur de votre choix.
                    Il existe également des e-cig jetables prêt à l’emploi (Pod HHC, Pod vape pen, Wpuff…).
                    Dans cette collection, découvrez notre large choix de variétés de cigarettes 
                    électronique au meilleur prix avec différents arômes / saveurs et taux de CBD ou HHC différents. 
                    Livraison gratuite et des promotions exceptionnelles toutes l'année.
                </p>
            </div>
          </div>
          {/*  modal panier*/}
          <div className="modal right modal-panier" id="rightModal" tabIndex="-1" aria-labelledby="rightModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg w-100">
                <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title text-center"  id="rightModalLabel mod-titre">PANIER</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body container">
                       {/* carousel */}
                        <div id="carouselExampleIndicators" className="carousel panier-carousel slide text-white pt-2 d-flex justify-content-between" data-bs-ride="carousel">
                          <div className="carousel-indicators panier-slider float-end d-flex me-auto">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                          </div>
                          <div className="carousel-inner ps-4 float-start">
                            <div className="carousel-item active">
                              <p>Juste un teste 1</p>
                            </div>
                            <div className="carousel-item">
                              <p>Juste un teste 2</p>
                            </div>
                            <div className="carousel-item">
                            <p>Juste un teste 3</p>
                            </div>
                          </div>
                        </div>
                      {/* fin carousel */}
                      <div className='modal-panier-group container mb-4 pb-5 mt-5'>
                        <div className='item-img'>
                          <img src={window.location.origin +"/images/produits/shopta.png"} alt="" />
                        </div>
                        <div className='item-md-detail'>
                          <div>
                            <h1 className='detail-title'>E-Liquide HHC</h1>
                            <p className='detail-text'>Menthe 20% HHC</p>
                            <div className='mb-3'>
                              <input type='number' className='text-dark' id='input-panier' min="1"/> <a type="button" className='ms-3 delete' id='delete'>Supprimer</a>
                            </div>
                            <p className='detail-point'>59 points de fidélité</p>
                          </div>
                          <div>
                            <h1 className='detail-price'>59,90£</h1>
                          </div>
                        </div>
                      </div>
                      <div className='like-md-group mt-1'>
                        <h1 className='like-title mt-5'>VOUS AIMEREZ AUSSI</h1>
                        <div className="cat-body container mt-5">
                          {
                            produits.map(prod => <div className="cat-item" key={prod.id}>
                              <Link className='item-title' to={{
                                pathname: "/produit/"+prod.id
                                  }}><img src={prod.image} alt="" id='img-prod' /></Link>
                                  <h3><Link className='item-title' to={{
                                        pathname: "/produit/"+prod.id
                                  }}>{prod.nom}</Link></h3>
                                  <p className='item-price'>{prod.prix} </p>
                                  <p className='item-note'>
                                  <span> {prod.note}</span> <span><img src={window.location.origin +"/images/start.png"} alt="" /></span><span className='avis'> {prod.avis} avis</span>
                                </p>
                            </div>)
                          }
                        
                    </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        {/* fin modal panier */}

        <Footer/>
    </div>
  )
}

export default Produit